"use client";
import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { UserCircle, ArrowUpRight } from "@mynaui/icons-react";
import { Button } from "@/components/ui/button";

import { sendGTMEvent } from "@next/third-parties/google";
import { Link } from "@/i18n/routing";
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import { useLocale } from "next-intl";
export default function HeaderDropDown({ profile, logout, getstarted }) {
  const googleTagHandler = (event) => {
    sendGTMEvent({ event });
  };
  const router = useRouter();
  const locale = useLocale();

  const pathname = usePathname();
  const currentPath = pathname.slice(3);
  const isPaymentPage =
    currentPath === "/checkout" ||
    currentPath === "/checkout/payment" ||
    currentPath === "/checkout/success" ||
    currentPath === "/checkout/fail";
  const isAuthPage =
    currentPath === "/auth/signin" || currentPath === "/auth/signup";
  return (
    <>
      {!isPaymentPage && !isAuthPage ? (
        <>
          {1 == 2 ? (
            <DropdownMenu modal={false}>
              <DropdownMenuTrigger className="md:ml-[202px]" asChild>
                <Button
                  aria-label="profile button"
                  variant="ghost"
                  className="p-0 hover:bg-transparent stroke-0 border-0 rounded-full"
                >
                  <UserCircle style={{ width: "32px", height: "32px" }} />
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem>
                  <p
                    className="overflow-hidden whitespace-nowrap text-ellipsis"
                    style={{ width: "90%" }}
                  >
                    {" "}
                    {/* //{session?.user?.email} */}
                  </p>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => router.push(`/${locale}/profile/scanner`)}
                  className={`flex items-center gap-2 cursor-pointer ${
                    currentPath === "/profile/scanner" ||
                    currentPath === "/profile/multichat"
                      ? "text-foreground/80"
                      : ""
                  }`}
                >
                  {profile}
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => signOut({ redirect: false })}
                  className="focus:text-red-700 flex items-center gap-2 cursor-pointer"
                >
                  {logout}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Link
              href="/auth/signin"
              className="cursor-pointer ml-2 xs:ml-4 md:ml-[83px] flex"
            >
              <Button
                onClick={() => googleTagHandler("header_click_getstarted")}
                className="hidden xxs:flex"
              >
                {getstarted}
                <ArrowUpRight
                  style={{ width: "24px", height: "24px" }}
                  className="w-8 h-8"
                />
              </Button>
            </Link>
          )}
        </>
      ) : null}
    </>
  );
}
